<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span class="fa fa-comment"></span>Messaging Bundles</div>
    <div class="loading" *ngIf="loading">
      <div class="loader"></div>
    </div>
  </div>

  <div class="content">
    <div class="row">
      <div style="margin-left: auto!important;margin-right:10px;" pTooltip="Add a Bundle"
           style="margin-right:32px;margin-left:auto;" tooltipPosition="left" class="fa fa-plus font-button pull-right"
           (click)="addBundle()"></div>
    </div>
    <div class="margin-top-16">
      <p-table #bundlesTable [columns]="columns" [value]="bundles" [paginator]="true" [rows]="20">
        <ng-template pTemplate="caption">

          <div class="row  justify-content-start mb-2">
            <div class="col-3 d-flex">
              <input type="text" pInputText size="50" placeholder="Search"
                     (input)="bundlesTable.filterGlobal($event.target['value'], 'contains')" style="width:auto">
              <i class="fa fa-search" style="margin-left: -30px; margin-top: 15px"></i>
            </div>
          </div>

          <!--          <div style="text-align: right">-->
          <!--            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>-->
          <!--            <input type="text" pInputText size="50" placeholder="Search"-->
          <!--                   (input)="bundlesTable.filterGlobal($event.target, 'contains')" style="width:auto">-->
          <!--            &lt;!&ndash;           todo (dcorbett) no more $event.target.value  &ndash;&gt;-->
          <!--          </div>-->
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''"
                [ngStyle]="{'width.px': col.field==='packageDescription' ? 300 : 'auto'}">
              {{col.header}}
              <p-sortIcon [field]="col.field" style="vertical-align: middle;" *ngIf="col.type !== 'action'">
              </p-sortIcon>
            </th>
            <th style="width: 60px;"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-bundle let-columns="columns">
          <tr [pSelectableRow]="bundle">
            <td *ngFor="let col of columns">
              <div *ngIf="col.type!=='action'">
                {{
                col.type === 'currency' ?
                  bundle['currencySymbol'] + (bundle[col.field] | number : '.2-2')
                  : col.type === 'currencyExtra' ?
                    bundle['currencySymbol'] + (bundle[col.field] | number : '.2-4')
                    : col.type === 'country' ?
                      getCountryName(bundle[col.field])
                      : col.type === 'type' ?
                        (bundle[col.field] === 3 ? "SMS" : "Other")
                        : bundle[col.field]
                }}
              </div>
            </td>
            <td style="text-align:left;">
              <div pTooltip="Delete this bundle" tooltipPosition="left" class="fa fa-trash font-button"
                   (click)="deleteBundle(bundle)"></div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>
</div>
<p-confirmDialog icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
